import { useEffect, useState } from 'react';

import appService from '../../service/app.service';
import { AutoCompleteSelectUI, CheckboxUI, DebouncedInputUI, FormLabelUI, SelectUI } from '../Interface';
import masterDataService from '../../service/masterData.service';
import useMenus from '../../context/MenuContext';
import { generateAutocompleteItems } from '../../utils/helper';
import { RoleRenderAutocomplete } from '../../config/roles';

export default function RoleListIformation({ roleState }) {
  const { menus, getMenus, getMenuSubMenuId } = useMenus();
  const { roleId } = roleState;
  const [roleListPermissions, setRoleListPermissions] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [refreshPage, setRefreshPage] = useState(false);
  const [autoCompleteOptions, setAutoCompleteOptions] = useState({
    classification: [],
  });
  const [submenuIds, setSubmenuIds] = useState({});
  const [roles, setRoles] = useState([]);
  const [filter, setFilter] = useState({
    name: '',
  });

  useEffect(() => {
    fetchAllRoleList();
    getMenus();
  }, []);

  useEffect(() => {
    if (Object.keys(submenuIds).length > 0) {
      initDefaultValues();
    }
  }, [submenuIds]);

  useEffect(() => {
    const resources = ['resourceOne'];

    const submenuMapping = resources.reduce((acc, resource) => {
      acc[resource] = getMenuSubMenuId(resource);
      return acc;
    }, {});

    setSubmenuIds(submenuMapping);
  }, [menus]);

  const initDefaultValues = () => {
    if (submenuIds['resourceOne']) {
      masterDataService
        .classificationToForm(submenuIds['resourceOne'])
        .then((data) => {
          const aData = {
            classification: data,
          };

          const acOptions = {
            classification: generateAutocompleteItems(aData.classification.classificationItem, 'name', 'id'),
          };
          setAutoCompleteOptions(acOptions);
        })
        .finally(() => {});
    }
  };

  const fetchData = async () => {
    if (!roleId) {
      return;
    }
    appService
      .getRoleInformation(roleId)
      .then((data) => {
        fetchRoleListPermissions();
      })
      .finally(() => {});
  };

  const fetchRoleListPermissions = async () => {
    appService
      .getRoleListPermissions(roleId)
      .then((data) => {
        setRoleListPermissions(data);
      })
      .finally(() => {});
  };

  const fetchAllRoleList = async () => {
    masterDataService
      .roleListsToForm()
      .then((data) => {
        setRoleList(data);
      })
      .finally(() => {});
  };

  useEffect(() => {
    const mergedRoles = roleList.map((role) => {
      const permission = roleListPermissions.find(
        (permission) => permission.roleListCode === role.code && permission.roleId === roleId
      );

      return {
        ...role,
        hasPermission: !!permission,
        value: permission?.value,
      };
    });

    setRoles(mergedRoles);
  }, [roles, roleListPermissions, roleId]);

  useEffect(() => {
    fetchData();
  }, [roleId]);

  useEffect(() => {
    fetchData();
  }, [refreshPage]);

  const handleChangeRole = async (roleList, permission, value) => {
    appService.updateRoleListPermission(roleId, roleList, permission, value).then(() => {
      const updatedList = roleListPermissions.map((p) =>
        p.roleListCode === roleList ? { ...p, hasPermission: permission } : p
      );
      setRoleListPermissions(updatedList);
      setRefreshPage(!refreshPage);
    });
  };

  return (
    <>
      <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6 max-h-[calc(100vh-10rem)] overflow-y-auto custom-scrollbar">
        <div>
          <div className="w-[250px] mb-3">
            <DebouncedInputUI
              label="Keresés"
              debounceMs={800}
              quickFilterSearchValue={filter?.name}
              setQuickFilterSearchValue={(newValue) => {
                setFilter((prevState) => ({
                  ...prevState,
                  name: newValue,
                }));
              }}
            />
          </div>
          <table className="mt-2 min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-1/2"
                >
                  Megnevezés
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-1/4"
                >
                  Értékek
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-1/4"
                >
                  Jogosult
                </th>
              </tr>
            </thead>
            <tbody>
              {roles
                .filter((role) => role.name.toLowerCase().includes(filter.name.toLowerCase()))
                .map((role, index) => {
                  const datasetKey = RoleRenderAutocomplete[role.code];

                  return (
                    <tr key={index} className="bg-white">
                      <td className="px-6 py-2 whitespace-nowrap text-sm font-medium text-gray-900 w-1/2">
                        {role.name}
                      </td>
                      <td className="px-6 py-2 whitespace-nowrap text-sm font-medium text-gray-900 w-1/4">
                        {datasetKey ? (
                          <SelectUI
                            label={<FormLabelUI text="Értékek" />}
                            option={autoCompleteOptions[datasetKey] || []}
                            onChange={(e) => handleChangeRole(role.code, true, e.target.value)}
                            disabled={!roleId}
                            value={parseInt(role?.value)}
                          />
                        ) : null}
                      </td>
                      <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-500 w-1/4">
                        {!datasetKey && (
                          <CheckboxUI
                            checked={role.hasPermission}
                            onChange={() => handleChangeRole(role.code, !role.hasPermission)}
                            disabled={!roleId}
                          />
                        )}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
